function RequiredArgumentError (name) {
  // Création de l'instance de l'erreur
  const instance = new Error(`Missing parameter: ${name}`)

  // Modification du nom de l'erreur
  instance.name = 'RequiredArgumentError'

  // Suppression de ce fichier dans la stacktrace
  const stack = instance.stack.split('\n')
  stack.splice(1, 2)
  instance.stack = stack.join('\n')

  // Retourne l'instance de l'erreur
  return instance
}

/**
 * Permet de rendre un argument d'une fonction obligatoire.
 * Pour fonctionner, cette méthode doit-être appelée en
 * tant que valeur par défaut de l'argument obligatoire.
 * Ex: function test (myArg = IsRequired('myArgs')) { ... }
 * Cela fonctionne car la valeur par défaut n'est lue que si
 * l'argument a pour valeur undefined
 *
 * @param {String} name Nom de l'argument (pour le message d'erreur)
 */
export default function IsRequired (name) {
  throw new RequiredArgumentError(name)
}
